import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { tv } from 'tailwind-variants';
// Local
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const phKeySmall = `custom-container-small-${props?.params?.DynamicPlaceholderId || 'container-25-75'}`;
    const phKeyMedium = `custom-container-medium-${props?.params?.DynamicPlaceholderId || 'container-25-75'}`;
    const { container, baseColumn, leftColumn, rightColumn } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsxs("div", {
        className: container(),
        ...getTestProps(`component-container-25-75-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `${baseColumn()} ${leftColumn()}`,
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeySmall,
                    rendering: props?.rendering,
                    ...getTestProps(`ph-left`)
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: `${baseColumn()} ${rightColumn()}`,
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeyMedium,
                    rendering: props?.rendering,
                    ...getTestProps(`ph-right`)
                })
            })
        ]
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'md:flex-row',
            'gap-spacing-spacing-40',
            'md:gap-spacing-spacing-24',
            'py-layout-base-margin-y'
        ],
        baseColumn: [
            'w-full',
            'grid',
            'grid-cols-1',
            'gap-layout-base-margin-none'
        ],
        leftColumn: [
            'md:w-1/4'
        ],
        rightColumn: [
            'md:w-3/4'
        ]
    }
});
